import NavBar from 'ageas-react-component-nav-bar'

import { AnimalsSecured, QuestionsBlock } from '../../Types/AnimalStore'
import { t } from '../../i18n'
import { CellNoPadding, RowNoPadding } from '../TablePacks/styles'
import { Coverages } from './Tabs/Coverages'
import { Declarations } from './Tabs/Declarations'
import { RiskData } from './Tabs/RiskData'
import { TabsContainer } from './styles'

type ExpandRowProps = {
  data: AnimalsSecured
}

export const ExpandRow = ({ data }: ExpandRowProps) => {
  return (
    <RowNoPadding>
      <CellNoPadding colSpan={6}>
        <TabsContainer>
          <NavBar
            id={'NavigationTabTable'}
            key={0}
            colorTheme="blue"
            tabs={[
              t('pages.step5.tabs.riskData'),
              t('pages.step5.tabs.statements'),
              t('pages.step5.tabs.coverage'),
            ]}
            table={{
              rows: [
                {
                  columns: [
                    {
                      componentCol: [<RiskData key="riskData" data={data} />],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      componentCol: [
                        <Declarations
                          key="declarations"
                          declarations={data.questionary as QuestionsBlock[]}
                          animalId={data.id}
                        />,
                      ],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      componentCol: [<Coverages key="coverages" data={data} />],
                    },
                  ],
                },
              ],
            }}
            activeTab={0}
            buttonNext={false}
            buttonLabel={t('pages.step5.tabs.next')}
            hasMaxWidth={true}
          />
        </TabsContainer>
      </CellNoPadding>
    </RowNoPadding>
  )
}
